import IconByPath, { IconByPathProps } from './Icon/IconType/IconByPath';

const IconLess = (props: IconByPathProps) => (
  <IconByPath {...props} path="M7.6 11.45h8.8v1.1H7.6v-1.1Z" />
);

export default IconLess;
